/**
 * 系统日志一览页面
 * 创建时间：2017-03-28
 * 创建人：masonchen
 * 修改人：baixx
 * 修改时间：2017-04-27
 */
<template>
<div class="wrapper-content fadeInRight animated tabBox" id="log-list">
     <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">	   	
	   	<!--表单查询开始-->
		<div class="form-horizontal">	
			<div class="form-group">
				<label class="col-sm-1 control-label">开始时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.startReqTime" class="form-control" ref="dateStartFrom"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					<span class="control-label gray">起止时间可只填其中一项</span>
				</div>
				<label class="col-sm-1 control-label">结束时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.endReqTime" class="form-control" ref="dateEndFrom"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">所属模块</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.menu1">  
						<option v-for="menu1 in menu1List" :value="menu1.id" >
							{{menu1.name}}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">二级模块</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.menu2">  
						<option v-for="menu2 in menu2List" :value="menu2.id" >
							{{menu2.name}}
						</option>
					</select>
					<span class="control-label gray">二级模块可以不选</span>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">日志内容</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim()="queryParam.content" maxlength="20">
				</div>
				<label class="col-sm-1 control-label">操作类别</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.operationType">  
						<option v-for="operationType in operationTypeList" :value="operationType.udccode" >
							{{operationType.udcname}}
						</option>
					</select>
				</div>
				<!--<label class="col-sm-1 control-label">操作人</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="queryParam.accountName">
				</div>-->
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button v-if="permission.indexOf('logList_select') == -1" class="btn btn-primary" @click="searchInfo" :disabled="!validDates">查询</button>
					<button v-if="permission.indexOf('logList_reset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
				</div>
			</div>
		</div>
		<!--表单查询结束-->
		<div class="hr-line-dashed"></div>
		<!--表格开始-->
		<table class="table mt20px table-striped table-bordered">
			<thead>
				<tr>
					<th>序号</th>
					<th>日志时间</th>
					<th>所属一级模块</th>
					<th>所属二级模块</th>
					<th>操作类别</th>
					<th>操作人</th>
					<th>日志内容</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(systemInfo,index) in systemLogData" v-bind:key="index">
					<td>{{index+1}}</td>
					<td>{{systemInfo.reqTime}}</td>
					<td>{{systemInfo.menu1Name}}</td>
					<td>{{systemInfo.menu2Name}}</td>
					<td>{{systemInfo.operationTypeName}}</td>
					<td>{{systemInfo.accountName}}</td>
					<td>{{systemInfo.content}}</td>
					<td class="text-center">
						<a v-if="permission.indexOf('logList_detail') == -1" class="text-left" @click="detail(index)">详情&nbsp;</a>
						<a v-if="permission.indexOf('logList_delete') == -1" class="text-center" @click="removeItem(index)">&nbsp;删除</a>
					</td>
				</tr>
			</tbody>
		</table>
		
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		
		<!--分页组件开始-->
		<pagination v-if="systemLogData.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
		<!--分页组件结束-->
		<sub-page :show="showSubPage" 
			:bigTitleMsg="title" 
			v-on:cancel="closeSubPage" 
			:scroll="scrollTop">
			
			<div slot="bodycontent">
				<page-log-detail :data="systemLogData[listIndex]" v-on:toClose="handleClose">
				</page-log-detail>
			</div>
		</sub-page>
	</div>
</div>	
</template>
<script>
	import SubPage from 'components/common/SubPage'
	import Pagination from 'components/common/Pagination'
	import TabModal from 'components/common/TabModal'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import PageLogDetail from 'components/pages/systemlog/PageLogDetail'	
	import Datepicker from 'components/common/datepicker/Datepicker'
	import {DICTIONARY_MAP} from 'static/constant'
    import {getDictionaryFromArray} from 'util/util'
    import classlist from 'util/classlist'
    
	export default {
		name: "PageLogList",
		components: {
			TabModal,
			Pagination,
			SubPage,
			PageLogDetail,
			Datepicker
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["logList"]?this.$store.state.permission.permission["logList"]:[],
				loadingstatus:false,
				messageStr: "",					    // 弹出框内容
				scrollTop: '0',
				showSubPage: false,
				title: "系统日志详情",
				listIndex: 0,		                // 列表索引
				systemLogData: [],                  // 系统日志信息列表
				pageInfo:{},
				menu1List: [],                      // 所属一级模块列表
				menu2List: [],                      // 所属二级模块列表
				operationTypeList: [],              // 操作类别列表
				udcType:[
				DICTIONARY_MAP.OPERATION_TYPE
				],
				queryParam:{											
					startReqTime: "",				// 日志时间开始
					endReqTime: "",					// 日志时间结束
					accountName: "",                // 操作人           
					userId:"",
					content: "",		            // 日志内容
					menu1: "",		                // 所属模块1
					menu2: "",					    // 所属模块2
					operationType: "",              // 操作类别
					page_index: 1,                  // 当前第几页
				},
			}
		},
		watch: {
			'queryParam.menu1'(){
				this.getMenueTwoInfo();
			}
		},
		computed: {
			//	起止时间是否合法
			validDates: function(){
				if(this.queryParam.startReqTime && this.queryParam.endReqTime && this.queryParam.startReqTime > this.queryParam.endReqTime){
					return false;
				} else {
					return true;
				}
			}
		},
		beforeMount() {
			//初始化信息接口
			this.getTableInfo();
			//获取一级所属模块
			this.getMenueOneInfo();
			//获取操作类别信息
			this.getoperationTypeInfo();
			
		},
		methods: {
			//查询方法
			searchInfo(){
				this.queryParam.page_index = 1;
				this.getTableInfo();
			},
			//初始化信息
			getTableInfo:function(){
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT + '/systemlog/sylogs', {params: this.queryParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;								
						const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
						this.pageInfo = {
							pageNum: pageNum,
							pages: pages,
							total: total,
							isFirstPage: isFirstPage,
							isLastPage: isLastPage
						}
						this.systemLogData = resInfo.list;
					} else {
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus = false;
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})
			},
			//获取所属一级模块信息
		    getMenueOneInfo: function () {
	       	  	this.$http.get(process.env.API_ROOT + '/systemlog/sys/resource/menu1')
				.then( res => {
				  	if(res.data.success) {
						this.menu1List = res.data.data;
					} else {
					}
				}, res => {
					
				})
				.catch( res => {
				}	
			)
           },
           //获取所属二级模块信息
		    getMenueTwoInfo: function () {
		    	if(this.queryParam.menu1 =='' || this.queryParam.menu1 == undefined) return;
	       	  	this.$http.get(process.env.API_ROOT + '/systemlog/sys/resource/menu1/' +  this.queryParam.menu1  + '/menu2')
				.then(res => {
					if(res.data.success) {
						this.menu2List = res.data.data;
					} else {
					}
				}, res => {
					
				})
				.catch( res => {
				}	
			)
           },
           //获取操作类别信息
		    getoperationTypeInfo: function () {
		    	if(this.udcType.length ==0) return;	
		    	let param = this.udcType.join(',');
				this.$http.get(process.env.API_ROOT + '/system/udcs',{params:{udcTypes: param}})
				.then(res => {
					if(res.data.success){
						this.operationTypeList = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.OPERATION_TYPE);
					}else{
						this.openModalMsg(res.data.message);
					}
				}, res => {
					this.openModalMsg(OPERATE_EXCEPTION);
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
				})
           },
           	//重置信息
			resetQueryParams:function(){
				this.$refs.dateStartFrom.handleClear();
				this.$refs.dateEndFrom.handleClear();
				this.queryParam = {
					startReqTime: "",				// 日志时间开始
					endReqTime: "",					// 日志时间结束
					accountName: "",                     // 操作人 
					content: "",		            // 日志内容
					menu1: "",		                // 所属模块1
					menu2: "",					    // 所属模块2
					operationType: "",              // 操作类别
					page_index: 1,                  // 当前第几页
				}
			},
			//从分页组件获取页码参数
			getPageNo(param) { 
				this.queryParam.page_index = param;
				this.getTableInfo();
			},
			//点击删除表格信息
			removeItem(index) { 
				//把index传给后台，由后台删除（再前台删除）
				this.systemLogData.splice(index, 1)
			},
			detail(index){
				this.listIndex = index;
				this.showSubPage = true;
				classlist.toggleScroll('close','#log-list',this);
			},
			closeSubPage(){
				this.showSubPage = false;
				classlist.toggleScroll('open','#log-list',this);
			},
			handleClose() { //点击关闭
				this.showSubPage = false;
				classlist.toggleScroll('open','#log-list',this);
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#log-list',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#log-list',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// PageLogList.vue?1d099a14